<template lang="pug">
  div Negocios
</template>
<script>
export default {
  
}
</script>